// PGCET MCA Mock 8 — Mathematics (questions 1–30)
const pgcetmcaMathematics = [
  {
    id: 1,
    question: "The 15th term of the arithmetic progression 3, 8, 13, 18, … is",
    options: ["A. 68", "B. 73", "C. 78", "D. 75"],
    answer: "B"
  },
  {
    id: 2,
    question: "How many terms of the arithmetic progression 24, 21, 18, … must be taken so that their sum is 78?",
    options: ["A. 4 only", "B. 13 only", "C. 4 or 13", "D. 6"],
    answer: "C"
  },
  {
    id: 3,
    question: "The differential equation of the family of curves y = A e²ˣ + B e⁻²ˣ, where A and B are arbitrary constants, is",
    options: ["A. d²y/dx² − 4y = 0", "B. d²y/dx² + 4y = 0", "C. dy/dx − 2y = 0", "D. d²y/dx² − 2y = 0"],
    answer: "A"
  },
  {
    id: 4,
    question: "The sum of the first 8 terms of the geometric progression 3, 6, 12, 24, … is",
    options: ["A. 765", "B. 768", "C. 381", "D. 1533"],
    answer: "A"
  },
  {
    id: 5,
    question: "Three numbers in geometric progression have a product of 216 and a sum of 19. The numbers are",
    options: ["A. 2, 6, 18", "B. 3, 6, 12", "C. 4, 6, 9", "D. 2, 6, 11"],
    answer: "C"
  },
  {
    id: 6,
    question: "The arithmetic mean and the geometric mean of two positive numbers are 10 and 8 respectively. The two numbers are",
    options: ["A. 2 and 18", "B. 5 and 15", "C. 6 and 14", "D. 4 and 16"],
    answer: "D"
  },
  {
    id: 7,
    question: "The recurring decimal 0.3555… (the digit 5 repeating) expressed as a fraction in lowest terms is",
    options: ["A. 32/99", "B. 16/45", "C. 7/20", "D. 35/99"],
    answer: "B"
  },
  {
    id: 8,
    question: "The coefficient of x⁵ in the expansion of (1 + 2x)⁷ is",
    options: ["A. 672", "B. 448", "C. 560", "D. 1344"],
    answer: "A"
  },
  {
    id: 9,
    question: "The term independent of x in the expansion of (2x + 1/(3x))⁶ is",
    options: ["A. 80/9", "B. 40/27", "C. 160/27", "D. 20/3"],
    answer: "C"
  },
  {
    id: 10,
    question: "In the expansion of (x + y)¹¹, the sum of the binomial coefficients of the terms in odd positions (1st, 3rd, 5th, …) is",
    options: ["A. 2048", "B. 1024", "C. 512", "D. 1023"],
    answer: "B"
  },
  {
    id: 11,
    question: "The particular solution of the differential equation x (dy/dx) = 2y satisfying y(1) = 3 is",
    options: ["A. y = x² + 2", "B. y = 2x + 1", "C. y = 3eˣ⁻¹", "D. y = 3x²"],
    answer: "D"
  },
  {
    id: 12,
    question: "The multiplicative inverse of the complex number 3 + 4i is",
    options: ["A. (3 − 4i)/25", "B. (3 − 4i)/5", "C. (−3 + 4i)/25", "D. (4 − 3i)/25"],
    answer: "A"
  },
  {
    id: 13,
    question: "The conjugate of the complex number (2 + i)/(1 − 2i) is",
    options: ["A. i", "B. −i", "C. 1", "D. −1"],
    answer: "B"
  },
  {
    id: 14,
    question: "The square roots of the complex number −8 − 6i are",
    options: ["A. ±(3 − i)", "B. ±(1 + 3i)", "C. ±(1 − 3i)", "D. ±(3 + i)"],
    answer: "C"
  },
  {
    id: 15,
    question: "In the Argand plane, the locus of the point z satisfying |z − 2| = |z + 2| is",
    options: ["A. the real axis", "B. a circle of radius 2 centred at the origin", "C. the line y = x", "D. the imaginary axis"],
    answer: "D"
  },
  {
    id: 16,
    question: "The polar form of the complex number 1 − i is",
    options: [
      "A. √2 (cos π/4 + i sin π/4)",
      "B. 2 (cos(−π/4) + i sin(−π/4))",
      "C. √2 (cos 3π/4 + i sin 3π/4)",
      "D. √2 (cos(−π/4) + i sin(−π/4))"
    ],
    answer: "D"
  },
  {
    id: 17,
    question: "The equation of the straight line that makes equal intercepts on the coordinate axes and passes through the point (3, 5) is",
    options: ["A. x + y = 8", "B. x − y = −2", "C. x + y = 2", "D. 3x + 5y = 34"],
    answer: "A"
  },
  {
    id: 18,
    question: "The foot of the perpendicular drawn from the origin to the line 3x + 4y = 25 is",
    options: ["A. (4, 3)", "B. (3, 4)", "C. (5, 0)", "D. (0, 25/4)"],
    answer: "B"
  },
  {
    id: 19,
    question: "The value of k for which the lines 2x + ky = 7 and 3x − 6y + 1 = 0 are perpendicular is",
    options: ["A. −1", "B. 4", "C. 1", "D. −4"],
    answer: "C"
  },
  {
    id: 20,
    question: "The value of k for which the lines x + y − 4 = 0, 2x − y − 2 = 0 and kx + 3y − 10 = 0 are concurrent is",
    options: ["A. 1", "B. 3", "C. 2", "D. −2"],
    answer: "C"
  },
  {
    id: 21,
    question: "The equation of the circle drawn on the line segment joining (1, 2) and (5, 6) as a diameter is",
    options: [
      "A. x² + y² − 6x − 8y + 17 = 0",
      "B. x² + y² + 6x + 8y + 17 = 0",
      "C. x² + y² − 6x − 8y − 17 = 0",
      "D. x² + y² − 4x − 4y + 17 = 0"
    ],
    answer: "A"
  },
  {
    id: 22,
    question: "The equation of the tangent to the circle x² + y² = 25 at the point (3, −4) is",
    options: ["A. 3x + 4y = 25", "B. 4x − 3y = 25", "C. 3x − 4y = 25", "D. 3x − 4y + 25 = 0"],
    answer: "C"
  },
  {
    id: 23,
    question: "The circles x² + y² − 6x = 0 and x² + y² + 2x = 0",
    options: [
      "A. intersect at two distinct points",
      "B. touch each other externally",
      "C. touch each other internally",
      "D. are such that one lies entirely inside the other without touching"
    ],
    answer: "B"
  },
  {
    id: 24,
    question: "The direction cosines of the line joining the points (1, −2, 3) and (3, 4, 6) are",
    options: ["A. 2/5, 6/5, 3/5", "B. 1/7, 3/7, 2/7", "C. 2/√7, 6/√7, 3/√7", "D. 2/7, 6/7, 3/7"],
    answer: "D"
  },
  {
    id: 25,
    question: "A line makes angles of 60° and 45° with the positive x-axis and y-axis respectively. The acute angle it makes with the positive z-axis is",
    options: ["A. 30°", "B. 45°", "C. 60°", "D. 90°"],
    answer: "C"
  },
  {
    id: 26,
    question: "The perpendicular distance of the point (2, 3, −5) from the plane x + 2y − 2z = 9 is",
    options: ["A. 3", "B. 9", "C. 6", "D. 1"],
    answer: "A"
  },
  {
    id: 27,
    question: "The angle between the planes 2x − y + z = 6 and x + y + 2z = 7 is",
    options: ["A. 45°", "B. 60°", "C. 90°", "D. 30°"],
    answer: "B"
  },
  {
    id: 28,
    question: "The general solution of the differential equation dy/dx = (1 + y²)/(1 + x²) is (C is an arbitrary constant)",
    options: ["A. y + x = C(1 − xy)", "B. y − x = C(1 + xy)", "C. y = Cx", "D. y − x = C(1 − xy)"],
    answer: "B"
  },
  {
    id: 29,
    question: "The variance of the first 10 natural numbers is",
    options: ["A. 9.5", "B. 5.5", "C. 2.87", "D. 8.25"],
    answer: "D"
  },
  {
    id: 30,
    question: "The mean of 5 observations is 4.4 and their variance is 8.24. If three of the observations are 1, 2 and 6, the remaining two observations are",
    options: ["A. 3 and 10", "B. 5 and 8", "C. 4 and 9", "D. 6 and 7"],
    answer: "C"
  }
];

export default pgcetmcaMathematics;
